import React, { useEffect, useState } from "react";
import { Clock, CalendarClock } from "lucide-react";

function diff(target) {
  const ms = new Date(target).getTime() - Date.now();
  if (ms <= 0) return null;
  const d = Math.floor(ms / 86400000);
  const h = Math.floor((ms % 86400000) / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  const s = Math.floor((ms % 60000) / 1000);
  return { d, h, m, s };
}

function Unit({ value, label }) {
  return (
    <div className="flex flex-col items-center">
      <span className="tabular-nums font-display text-xl md:text-2xl font-bold leading-none">
        {String(value).padStart(2, "0")}
      </span>
      <span className="text-[10px] uppercase tracking-wider opacity-70 mt-1">{label}</span>
    </div>
  );
}

export default function MarketDayBanner({ status }) {
  const open = status?.is_open;
  const closeAt = status?.orders_close;
  const [t, setT] = useState(() => (closeAt ? diff(closeAt) : null));

  useEffect(() => {
    if (!open || !closeAt) return;
    setT(diff(closeAt));
    const id = setInterval(() => setT(diff(closeAt)), 1000);
    return () => clearInterval(id);
  }, [open, closeAt]);

  if (!status) return null;

  return (
    <div
      data-testid="market-day-banner"
      className={`relative overflow-hidden rounded-2xl px-5 py-4 ${open ? "bg-[#1A4331] text-white" : "bg-slate-800 text-white"}`}
    >
      <div className="grain absolute inset-0 opacity-40 pointer-events-none" />
      <div className="relative flex items-center gap-3 flex-wrap">
        <div className={`shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${open ? "bg-[#228B22]" : "bg-red-500/90"}`}>
          {open ? <Clock size={20} /> : <CalendarClock size={20} />}
        </div>
        <div className="min-w-0 flex-1 basis-[calc(100%-3.25rem)] sm:basis-0">
          <div className="flex items-center gap-2">
            <span className={`inline-block w-2 h-2 rounded-full ${open ? "bg-[#7CFC7C] animate-pulse" : "bg-red-400"}`} />
            <p className="text-xs font-semibold uppercase tracking-wider opacity-80">
              {open ? "Market Day is Open" : "Market Day Closed"}
            </p>
          </div>
          <p className="font-display text-lg font-semibold leading-snug">{status.message}</p>
        </div>
        {open && t && (
          <div data-testid="countdown-timer" className="flex items-center gap-3 bg-black/20 rounded-xl px-4 py-2 w-full justify-center sm:w-auto">
            {t.d > 0 && <Unit value={t.d} label="days" />}
            <Unit value={t.h} label="hrs" />
            <Unit value={t.m} label="min" />
            <Unit value={t.s} label="sec" />
          </div>
        )}
      </div>
    </div>
  );
}
